import React, { useEffect, useState } from 'react';
import { EVENT_NAMES } from '../../constants/mixpanel';
import { mixpanelTrackEvent } from '../../utils/mixpanel/common';

interface IProfilerComponentProps {
  page: string;
}

const TrackLoadingToMixpanel: React.FC<IProfilerComponentProps> = (props: IProfilerComponentProps) => {
  const { page } = props;
  const [startTime] = useState(Date.now());

  useEffect(() => {
    return () => {
      const endTime = Date.now();
      const waitTime = endTime - startTime;
      const Duration = waitTime / 1000; // in seconds

      // Don't send pre mature loading time of sending payment
      if (page === 'Payment' && Duration < 1) {
        return;
      }

      mixpanelTrackEvent({
        eventName: EVENT_NAMES.WAIT_TIME,
        payload: {
          eventProperties: {
            Duration,
            Content: page,
          },
        },
      });
    };
  }, []);

  return null;
};

export default TrackLoadingToMixpanel;
